let u = JSON.parse(window.localStorage.getItem("userData"));
export const initialState = {
  user: u ? u : null,
  token: "pk_d6a17e8fe517447080c884bebb79ef04",
};

const Reducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      //   console.log("action user", action.user);
      return {
        ...state,
        user: action.user,
      };

    default:
      return state;
  }
};
export default Reducer;
